const modals = document.querySelectorAll(".modal");
const modalWrapper = document.querySelector(".modal-wrapper");
const closeModalBtns = document.querySelectorAll(".packs-modal-close");

if (closeModalBtns) {
	closeModalBtns.forEach((btn) => {
		btn.addEventListener("click", () => {
			btn.parentElement.classList.remove("active");
			modalWrapper.classList.add("hidden");
			document.documentElement.style.overflowY = "unset";
		});
	});
}

modalWrapper.addEventListener("click", (e) => {
	if (e.target.classList.contains("modal-wrapper") && modals) {
		modals.forEach((modal) => modal.classList.remove("active"));
		document.documentElement.style.overflowY = "unset";
		modalWrapper.classList.add("hidden");
	}
});
